









































































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* 以下画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { masterCodeModule } from '../store/modules/MasterCode'; // ストアモジュール
import { IMC } from '../store/dto/MasterCode'; // dto
import { KanriConstants } from '../fixed/KanriConstants';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class MasterCodeSearch extends ApiAccessBase {
  // 拡張パネルの設定（検索条件）
  private searchPanel: number[] = [0];  //初期表示展開
  // 検索結果ヘッダの設定
  private headers = [
    {
      text: '削除',
      align: 'center',
      sortable: false,
      value: 'delete',
    },
    {
      text: 'コード番号',
      align: 'center',
      sortable: true,
      value: 'codeNo',
    },
    {
      text: 'コード名称',
      align: 'center',
      sortable: true,
      value: 'codeValue',
    },
    {
      text: '表示順',
      align: 'center',
      sortable: true,
      value: 'displayOrder',
    },
  ];
  // 画面初期化処理
  // component生成時に実行
  private created() {
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['masterCode_search']);
    const path = KanriConstants.CODE_PATH + masterCodeModule.GET_PATH;
    // TODO 登録画面から戻った際の再検索
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        this.searchCode(); //検索
      }
    });
  }

  /**
   * コード表登録画面への遷移
   * (新規追加ボタン押下時に発火)
   */
  private moveInfo() {
    router.push({ name: 'masterCodeInfo' });
  }

  /**
   * コード表の削除
   * (表削除列_削除アイコン押下時に発火)
   */
  private deleteCode(param: IMC) {
    if (window.confirm(Message.I0001)) {
      masterCodeModule.setCodeTable2(param);
      // APIアクセス
      this.apiAccess(
        KanriConstants.CODE_PATH + masterCodeModule.GET_PATH2
           , Constants.API_METHOD_POST, false, false)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          // 成功
          alert(Message.I0002);
          this.searchCode(); //再検索
        } else {
          // 失敗
          alert(Message.E0000);
        }
      });
    }
  }

  // /**
  //  * コード表の編集
  //  * (編集列_編集アイコン押下時に発火)
  //  */
  // private dataTransferInfo(param: IMCT) {
  //   masterCodeModule.setCodeTable(param);
  //   masterCodeModule.transferToInfo();
  //   router.push({ name: 'masterCodeTableInfo' });
  // }

  /**
   * コードの編集(コード登録画面への遷移)
   * (コード番号列_編集アイコン押下時に発火)
   */
  private dataTransferInfo2(param: IMC) {
    masterCodeModule.setCodeTable2(param);
    masterCodeModule.transferToInfo();
    router.push({ name: 'masterCodeInfo' });
  }

  /**
   * コード表の検索
   * (画面初期表示時に発火)
   */
  private searchCode() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    // ＜関連チェックをいれるならここ＞
    this.apiAccess(KanriConstants.CODE_OB_DISPLAY_ORDER_PATH, Constants.API_METHOD_POST, true, true);
  }
}
